(function(){
'use strict';

var root = document.querySelector('.tcm-ref');
if (!root) { initFAQ(); return; }

var isB2B = root.dataset.b2b === 'true';
var indexUrl = root.dataset.indexUrl;
var catalogEl = document.getElementById('tcm-catalog');

initFAQ();

if (!catalogEl || !indexUrl) return;

var patternName = catalogEl.dataset.pattern || null;
var actionName = catalogEl.dataset.action || null;
var systemName = catalogEl.dataset.system || null;
if (!patternName && !actionName && !systemName) return;

var PAGE_SIZE = 24;
var gridEl = document.getElementById('tcm-products-grid');
var countEl = document.getElementById('tcm-product-count');
if (!gridEl) return;

function dp(r, w) { return (isB2B && w != null) ? w : r; }
function fmt(p) { return '$' + parseFloat(p).toFixed(2); }
function thumbUrl(src) {
  if (!src) return '';
  if (src.indexOf('width=') !== -1) return src.replace(/width=\d+/, 'width=300');
  return src + (src.indexOf('?') !== -1 ? '&' : '?') + 'width=300';
}
function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

function buildCard(p, vendorsLookup, imgBase) {
  var vendor = vendorsLookup[p.v] || '';
  var price = dp(p.pr, p.wpr);
  var rawSrc = p.img ? imgBase + p.img : '';
  var imgSrc = thumbUrl(rawSrc);
  var imgHtml = imgSrc
    ? '<img src="' + imgSrc + '" alt="' + esc(p.t) + '" loading="lazy">'
    : '<div style="height:200px;background:#f9f9f9;display:flex;align-items:center;justify-content:center;color:#b3b3b3;font-size:13px;">No image</div>';
  return '<a href="/products/' + p.h + '" class="tcm-product-card" style="text-decoration:none;color:inherit;">'
    + imgHtml
    + '<div class="tcm-product-info">'
    + '<p class="tcm-product-title">' + esc(p.t) + '</p>'
    + '<p class="tcm-product-vendor">' + esc(vendor) + '</p>'
    + (price ? '<p class="tcm-product-price">' + fmt(price) + '</p>' : '')
    + '</div></a>';
}

fetch(indexUrl)
  .then(function(r) { return r.json(); })
  .then(function(data) {
    var vendorsLookup = {};
    data._vendors.forEach(function(v, i) { vendorsLookup[i] = v; });
    var matches = [];

    if (patternName) {
      var pLk = {}; data._patterns.forEach(function(v, i) { pLk[i] = v; });
      data.products.forEach(function(p) {
        var pats = (p.pa || []).map(function(i) { return pLk[i]; });
        if (pats.indexOf(patternName) !== -1) matches.push(p);
      });
    } else if (actionName) {
      var aLk = {}; data._actions.forEach(function(v, i) { aLk[i] = v; });
      data.products.forEach(function(p) {
        var acts = [];
        if (p.ap !== undefined) acts.push(aLk[p.ap]);
        (p.as || []).forEach(function(i) { acts.push(aLk[i]); });
        if (acts.indexOf(actionName) !== -1) matches.push(p);
      });
    } else if (systemName) {
      var sLk = {}; data._systems.forEach(function(v, i) { sLk[i] = v; });
      data.products.forEach(function(p) {
        var sys = (p.sy || []).map(function(i) { return sLk[i]; });
        if (sys.indexOf(systemName) !== -1) matches.push(p);
      });
    }

    if (countEl) countEl.textContent = matches.length + ' formula' + (matches.length !== 1 ? 's' : '') + ' in our catalog';
    if (!matches.length) { gridEl.style.cssText = ''; gridEl.innerHTML = '<p style="color:#7a7a7a;font-size:14px;">No formulas currently in stock.</p>'; return; }

    matches.sort(function(a, b) { return a.t.localeCompare(b.t); });
    gridEl.style.cssText = 'display:grid;grid-template-columns:repeat(auto-fill,minmax(200px,1fr));gap:1rem;';
    var shown = 0;
    function renderBatch() {
      var end = Math.min(shown + PAGE_SIZE, matches.length);
      var frag = document.createDocumentFragment();
      for (var i = shown; i < end; i++) {
        var tmp = document.createElement('div');
        tmp.innerHTML = buildCard(matches[i], vendorsLookup, data.imgBase);
        frag.appendChild(tmp.firstChild);
      }
      var oldBtn = catalogEl.querySelector('.tcm-show-more');
      if (oldBtn) oldBtn.remove();
      gridEl.appendChild(frag);
      shown = end;
      if (shown < matches.length) {
        var btn = document.createElement('button');
        btn.className = 'tcm-show-more';
        btn.textContent = 'Show more (' + (matches.length - shown) + ' remaining)';
        btn.style.cssText = 'display:block;margin:20px auto 0;padding:10px 32px;background:#f3f3f3;border:1px solid #e8e8e8;border-radius:8px;font-size:14px;font-weight:600;color:#1a1c1c;cursor:pointer;font-family:inherit;transition:background-color 0.15s ease;';
        btn.onmouseover = function(){ btn.style.backgroundColor='#f7b22e'; btn.style.color='#684700'; };
        btn.onmouseout = function(){ btn.style.backgroundColor='#f3f3f3'; btn.style.color='#1a1c1c'; };
        btn.addEventListener('click', function() { renderBatch(); });
        catalogEl.appendChild(btn);
      }
    }
    gridEl.innerHTML = '';
    renderBatch();
  })
  .catch(function() { gridEl.style.cssText = ''; gridEl.innerHTML = '<p style="color:#ba1a1a;font-size:14px;">Failed to load products. Please refresh.</p>'; });

function initFAQ() {
  document.querySelectorAll('.tcm-faq-item').forEach(function(item) {
    var btn = item.querySelector('.tcm-faq-q');
    if (btn) btn.addEventListener('click', function() { item.classList.toggle('open'); });
  });
}
})();
